import { render, staticRenderFns } from "./CargoDetailDialog.vue?vue&type=template&id=493dba20&scoped=true"
import script from "./CargoDetailDialog.vue?vue&type=script&lang=js"
export * from "./CargoDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CargoDetailDialog.vue?vue&type=style&index=0&id=493dba20&prod&lang=css"
import style1 from "./CargoDetailDialog.vue?vue&type=style&index=1&id=493dba20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493dba20",
  null
  
)

export default component.exports